@if (avatarData()) {
	<au-round-avatar
		[matTooltip]="nameOnHover ? nameText() : null"
		[class.clickable]="clickable"
		class="avatar"
		[data]="avatarData()"
		[size]="size"
	></au-round-avatar>

	@if (nameText()) {
		<div [class.clickable]="clickable" class="name-text">
			{{ nameText() }}
		</div>
	}
}
